import { UseCase } from '@/core/base/use-case';
import { Observable } from 'rxjs';
import { GtmRepository } from '../repositories/gtm.repository';

export class GtmPurchaseUseCase implements UseCase<string, boolean> {
    constructor(private readonly repository: GtmRepository) {}

    execute(reservationCode: string): Observable<boolean> {
        return this.repository.purchase(reservationCode);
    }
}
